// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Logisticinpune() {



const cardData = {


    keyword: "Logistics in Pune",

    headingDescription: "SSK Logistic delivers structured and dependable logistics in Pune for businesses that require efficient freight movement, cargo transportation, industrial distribution, commercial deliveries, warehouse coordination, and supply chain support. With organized transportation planning and route management, SSK Logistic supports shipments moving from Pune to major industrial and commercial destinations across Maharashtra and other parts of India. The service approach is designed around practical scheduling, suitable vehicle coordination, shipment handling, documentation support, and consistent communication, helping manufacturers, distributors, retailers, corporate clients, and commercial businesses manage their logistics requirements with greater operational convenience.",

    topPlaces: [
        {
            title: "Pune to Chakan Logistics Service",
            description: "SSK Logistic supports regular cargo and industrial logistics movement from Pune to Chakan, an important manufacturing and warehousing hub. Services can accommodate factory materials, commercial consignments, machinery, components, and distribution loads with route planning suited to recurring business transportation requirements."
        },
        {
            title: "Pune to Navi Mumbai Freight Transportation",
            description: "Freight transportation from Pune to Navi Mumbai connects businesses with major warehousing, distribution, port-linked, and commercial zones. SSK Logistic coordinates cargo movement with practical scheduling and suitable transportation arrangements for manufacturers, traders, distributors, and corporate supply chains."
        },
        {
            title: "Pune to Nashik Cargo Logistics",
            description: "Cargo logistics from Pune to Nashik is suitable for businesses moving industrial goods, commercial inventory, packaging materials, equipment, and other consignments. SSK Logistic focuses on organized pickup and delivery coordination to support dependable movement between these important business regions."
        },
        {
            title: "Pune to Ahmedabad Industrial Logistics",
            description: "SSK Logistic facilitates industrial logistics from Pune toward Ahmedabad for companies handling manufacturing materials, machinery, commercial products, and bulk business consignments. Planned transportation helps businesses coordinate longer-distance cargo requirements across established industrial corridors."
        },
        {
            title: "Pune to Hyderabad Supply Chain Logistics",
            description: "Supply chain logistics between Pune and Hyderabad can support manufacturers, distributors, technology businesses, and commercial enterprises requiring intercity cargo movement. SSK Logistic manages transportation coordination with attention to scheduling, shipment requirements, and delivery-point planning."
        },
        {
            title: "Pune to Indore Commercial Logistics",
            description: "Commercial logistics from Pune to Indore provides transportation support for retailers, wholesalers, manufacturers, and distributors moving products and business inventory. SSK Logistic coordinates suitable freight transportation based on cargo characteristics, delivery requirements, and planned routes."
        },
        {
            title: "Pune to Surat Freight Logistics",
            description: "Freight logistics between Pune and Surat supports the movement of commercial inventory, industrial supplies, textile-related goods, equipment, and business consignments. SSK Logistic provides coordinated transportation assistance for companies requiring regular or scheduled cargo movement."
        },
        {
            title: "Pune to Bengaluru Cargo Transportation",
            description: "Cargo transportation from Pune to Bengaluru helps businesses manage long-distance movement of commercial products, industrial materials, machinery, and distribution stock. SSK Logistic combines route planning and transportation coordination to support organized deliveries across the interstate corridor."
        },
        {
            title: "Pune to Nagpur Logistics Transportation",
            description: "Logistics transportation from Pune to Nagpur supports businesses moving goods across Maharashtra, including industrial materials, commercial consignments, warehouse stock, and equipment. SSK Logistic coordinates pickup, transit planning, and delivery requirements for diverse business shipments."
        },
        {
            title: "Pune to Delhi NCR Logistics Support",
            description: "SSK Logistic provides logistics support for businesses transporting cargo from Pune toward Delhi NCR and surrounding commercial markets. The service is suited to manufacturers, distributors, corporate businesses, and traders requiring organized long-distance freight movement and delivery coordination."
        }
    ],

    "services": [
        {
            "name": "Logistics Services in Pune",
            "description": "SSK Logistic provides logistics services in Pune for businesses requiring coordinated cargo movement, commercial transportation, industrial deliveries, warehouse transfers, and distribution support. Transportation planning is organized around shipment type, destination, scheduling requirements, and practical delivery coordination."
        },
        {
            "name": "Logistics Company Pune",
            "description": "Businesses searching for a logistics company Pune can rely on SSK Logistic for structured transportation assistance across local, regional, and interstate routes. The service supports manufacturers, distributors, retailers, corporate clients, and commercial operators with organized freight and cargo movement."
        },
        {
            "name": "Logistics Providers Pune",
            "description": "SSK Logistic works as a logistics partner for companies looking for dependable logistics providers Pune with transportation, cargo handling, distribution, and delivery coordination capabilities. Services can be planned around recurring business requirements as well as individual shipment movements."
        },
        {
            "name": "Logistics Solutions in Pune",
            "description": "Customized logistics solutions in Pune from SSK Logistic help businesses coordinate transportation, cargo movement, warehouse transfers, distribution requirements, and route planning. Each logistics arrangement can be structured according to shipment volume, destination, delivery schedule, and operational needs."
        },
        {
            "name": "Logistics Service Provider Pune",
            "description": "SSK Logistic operates as a logistics service provider Pune businesses can approach for organized freight transportation, commercial cargo movement, industrial logistics, and distribution support. The focus remains on practical coordination from pickup planning through delivery."
        },
        {
            "name": "Freight Logistics Pune",
            "description": "Freight logistics Pune services from SSK Logistic are designed for businesses transporting industrial goods, commercial inventory, machinery, raw materials, and other freight consignments. Route planning and vehicle coordination help maintain an organized flow of shipments across important business corridors."
        },
        {
            "name": "Cargo Logistics Pune",
            "description": "Cargo logistics Pune requirements can be managed through SSK Logistic with transportation planning suited to different shipment sizes and business destinations. The service supports cargo pickup, intercity transportation, delivery coordination, and ongoing communication for commercial shipments."
        },
        {
            "name": "Industrial Logistics Pune",
            "description": "SSK Logistic supports industrial logistics Pune requirements for manufacturers and industrial units moving raw materials, machinery, components, finished products, and plant-related cargo. Transportation can be arranged around production schedules, dispatch requirements, and destination-specific delivery planning."
        },
        {
            "name": "Commercial Logistics Pune",
            "description": "Commercial logistics Pune services from SSK Logistic assist retailers, wholesalers, distributors, traders, and corporate businesses with planned movement of inventory and commercial consignments. The service focuses on suitable transportation, route coordination, and dependable delivery scheduling."
        },
        {
            "name": "Transportation Logistics Pune",
            "description": "SSK Logistic manages transportation logistics Pune requirements through coordinated route planning, vehicle selection, pickup scheduling, cargo movement, and delivery arrangements. This approach helps businesses maintain smoother transportation operations across local and long-distance routes."
        },
        {
            "name": "Supply Chain Logistics Pune",
            "description": "Supply chain logistics Pune support from SSK Logistic helps businesses coordinate the transportation side of their supply chain, including movement between suppliers, warehouses, manufacturing units, distributors, and customers. Structured planning helps maintain better continuity across multiple logistics stages."
        },
        {
            "name": "Warehouse Logistics Pune",
            "description": "Warehouse logistics Pune services can include transportation between warehouses, factories, distribution points, and commercial locations. SSK Logistic coordinates cargo movement according to loading requirements, destination schedules, and recurring stock-transfer needs."
        },
        {
            "name": "Third Party Logistics Pune",
            "description": "SSK Logistic supports third party logistics Pune requirements for businesses seeking external assistance with transportation and distribution activities. Services can be coordinated for recurring dispatches, intercity freight movement, warehouse transfers, and customer delivery requirements."
        },
        {
            "name": "Logistics Management Pune",
            "description": "Logistics management Pune support from SSK Logistic focuses on organizing transportation activities, shipment schedules, route planning, vehicle coordination, and delivery requirements. Businesses can streamline their logistics operations through structured movement planning and consistent communication."
        },
        {
            "name": "End to End Logistics Pune",
            "description": "End to end logistics Pune services from SSK Logistic are structured to support multiple stages of business cargo movement, from pickup and transportation planning to destination delivery coordination. The approach is suitable for companies seeking a more organized logistics process through a single service partner."
        },
        {
            "name": "Logistics Transportation Services Pune",
            "description": "SSK Logistic provides logistics transportation services Pune businesses can use for industrial freight, commercial cargo, warehouse transfers, and interstate shipments. Transportation planning is aligned with the nature of the goods, route distance, delivery requirements, and business schedule."
        },
        {
            "name": "Cargo Transportation Pune",
            "description": "Cargo transportation Pune services from SSK Logistic support businesses moving products, machinery, raw materials, commercial stock, and other consignments. Pickup and delivery schedules are coordinated to provide a practical transportation arrangement for different types of business cargo."
        },
        {
            "name": "Freight Transportation Pune",
            "description": "Freight transportation Pune solutions from SSK Logistic help businesses move heavier and commercial consignments between Pune and important industrial or market destinations. Route coordination and suitable vehicle planning support smoother handling of scheduled freight requirements."
        },
        {
            "name": "Local Logistics Services Pune",
            "description": "Local logistics services Pune from SSK Logistic cover transportation requirements between factories, warehouses, distribution centers, commercial locations, and business premises. The service is useful for recurring local movement as well as planned short-distance cargo deliveries."
        },
        {
            "name": "Corporate Logistics Pune",
            "description": "Corporate logistics Pune services are designed for companies requiring dependable transportation support for office supplies, commercial inventory, equipment, documents, materials, and distribution requirements. SSK Logistic coordinates business-focused logistics arrangements around scheduled pickup and delivery needs."
        },
        {
            "name": "Logistics Support Pune",
            "description": "SSK Logistic offers logistics support Pune businesses can use when they need assistance with transportation planning, cargo movement, warehouse transfers, route coordination, and delivery scheduling. Flexible logistics support helps companies manage changing shipment requirements more efficiently."
        },
        {
            "name": "Professional Logistics Services Pune",
            "description": "Professional logistics services Pune from SSK Logistic combine organized transportation planning with cargo coordination and delivery management for commercial and industrial customers. The service approach emphasizes clear scheduling, suitable vehicle arrangements, and practical shipment handling."
        },
        {
            "name": "Reliable Logistics Services Pune",
            "description": "Reliable logistics services Pune businesses require can be coordinated through SSK Logistic for recurring freight, cargo, commercial, and industrial transportation. Consistent communication and planned movement schedules help businesses maintain better control over their transportation requirements."
        },
        {
            "name": "Logistics Partner Pune",
            "description": "SSK Logistic serves as a logistics partner Pune businesses can work with for regular transportation, freight movement, cargo delivery, warehouse transfers, and interstate logistics. Solutions can be adapted to recurring routes and changing business shipment requirements."
        },
        {
            "name": "Logistics Company Near Pune",
            "description": "Companies searching for a logistics company near Pune can use SSK Logistic for local, regional, and long-distance cargo transportation requirements. The service supports industrial areas, commercial markets, warehouses, manufacturing units, and business destinations through coordinated logistics planning."
        }
    ],

    "tableData": [
        ["Logistics Services in Pune", "Logistics Company Pune"],
        ["Logistics Providers Pune", "Logistics Solutions in Pune"],
        ["Logistics Service Provider Pune", "Freight Logistics Pune"],
        ["Cargo Logistics Pune", "Industrial Logistics Pune"],
        ["Commercial Logistics Pune", "Transportation Logistics Pune"],
        ["Supply Chain Logistics Pune", "Warehouse Logistics Pune"],
        ["Third Party Logistics Pune", "Logistics Management Pune"],
        ["End to End Logistics Pune", "Logistics Transportation Services Pune"],
        ["Cargo Transportation Pune", "Freight Transportation Pune"],
        ["Local Logistics Services Pune", "Corporate Logistics Pune"],
        ["Logistics Support Pune", "Professional Logistics Services Pune"],
        ["Reliable Logistics Services Pune", "Logistics Partner Pune"],
        ["Logistics Company Near Pune", "Logistics in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Structured Transportation Planning",
            WhyChoosedescription: "SSK Logistic organizes transportation requirements around cargo type, destination, route distance, loading conditions, and delivery schedules, helping businesses maintain a more systematic approach to their logistics operations."
        },
        {
            WhyChooseheading: "Wide Business Route Coverage",
            WhyChoosedescription: "From Pune's industrial zones to major commercial markets across Maharashtra and other states, SSK Logistic supports a broad range of logistics routes for businesses managing regular and occasional cargo movements."
        },
        {
            WhyChooseheading: "Industrial Cargo Handling Support",
            WhyChoosedescription: "Manufacturers and industrial businesses can coordinate transportation for machinery, raw materials, components, finished products, and other operational cargo with logistics arrangements planned around their specific movement requirements."
        },
        {
            WhyChooseheading: "Flexible Commercial Logistics",
            WhyChoosedescription: "Retailers, distributors, wholesalers, and corporate customers can use flexible transportation arrangements for inventory transfers, warehouse movements, market deliveries, and scheduled commercial consignments."
        },
        {
            WhyChooseheading: "Route-Focused Coordination",
            WhyChoosedescription: "Each shipment can be planned according to its origin, destination, expected schedule, and cargo requirements, allowing SSK Logistic to coordinate practical routes for local, regional, and interstate transportation."
        },
        {
            WhyChooseheading: "Support for Recurring Shipments",
            WhyChoosedescription: "Businesses with regular dispatch schedules can coordinate recurring transportation requirements with SSK Logistic, making it easier to manage repeated routes, warehouse transfers, supplier movements, and distribution activities."
        },
        {
            WhyChooseheading: "Business-Centric Service Approach",
            WhyChoosedescription: "SSK Logistic focuses on commercial and industrial transportation needs, providing logistics coordination that considers operational schedules, shipment priorities, destination requirements, and the practical demands of business cargo movement."
        },
        {
            WhyChooseheading: "Coordinated End-to-End Movement",
            WhyChoosedescription: "From pickup planning and vehicle coordination to transit management and delivery scheduling, SSK Logistic helps businesses organize multiple transportation stages through a coordinated logistics service."
        }
    ]

};









const faqData = [
    {
        question: "What logistics solutions are available from SSK Logistic in Pune?",
        answer: "SSK Logistic supports businesses in Pune with goods transportation and logistics coordination for commercial and industrial consignments, with arrangements based on cargo requirements, routes, vehicle capacity, and delivery schedules."
    },
    {
        question: "Can SSK Logistic move goods from Pune to locations across India?",
        answer: "Yes, cargo transportation can be planned from Pune to destinations throughout Maharashtra and other parts of India, including major commercial cities such as Mumbai, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, and more."
    },
    {
        question: "What types of shipments can be handled by SSK Logistic?",
        answer: "Suitable shipments may include commercial stock, industrial supplies, machinery, equipment, packaged goods, raw materials, finished products, warehouse transfers, and other business consignments according to their transportation requirements."
    },
    {
        question: "Can SSK Logistic assist businesses with recurring logistics requirements?",
        answer: "Companies that frequently move goods can discuss recurring transportation arrangements with schedules planned around regular pickup points, delivery routes, shipment volumes, vehicle requirements, and business timelines."
    },
    {
        question: "What information is required to plan a logistics shipment in Pune?",
        answer: "Useful shipment details include the pickup location, delivery destination, cargo type, approximate weight or quantity, dimensions when relevant, loading requirements, preferred vehicle, and expected delivery timeframe."
    },
    {
        question: "Does SSK Logistic provide Pune to Mumbai goods transportation?",
        answer: "Businesses can arrange cargo movement between Pune and Mumbai for commercial stock, industrial materials, equipment, supplies, machinery, and other suitable consignments requiring transportation between these locations."
    },
    {
        question: "Can SSK Logistic arrange long-distance cargo transportation from Pune?",
        answer: "Long-distance movement can be coordinated from Pune toward northern, southern, western, and central Indian destinations, with the transportation plan adjusted according to the cargo and route requirements."
    },
    {
        question: "Are SSK Logistic services useful for manufacturers and distributors?",
        answer: "Manufacturers, distributors, suppliers, warehouses, and industrial businesses can use transportation support for moving raw materials, finished goods, machinery, equipment, inventory, and other commercial consignments."
    },
    {
        question: "Can transportation be planned according to the size of the cargo?",
        answer: "Vehicle selection and transportation planning can be adjusted according to shipment weight, dimensions, quantity, loading conditions, route distance, and the nature of the goods being moved."
    },
    {
        question: "How can a business contact SSK Logistic for logistics in Pune?",
        answer: "Businesses can begin by sharing their pickup point, destination, cargo details, approximate shipment quantity, vehicle requirement, and delivery schedule to discuss a transportation arrangement suitable for their logistics needs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vishal Khedekar",
        feedback: "Our Pune-based business needed transportation for finished products going to Indore. SSK Logistic coordinated the shipment according to our cargo details and made the overall movement easier for our operations team.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Pooja Nair",
        feedback: "We contacted SSK Logistic for moving commercial materials from Pune to Hyderabad. The team was responsive about the vehicle requirement and helped us coordinate the transportation without unnecessary complications.",
        rating: 5
    }
];


















    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Logistics in Pune",
  "image": "https://ssklogistics.in/assets/images/logistics-in-pune.webp",
  "description": "SSK Logistics provides organized logistics support in Pune for businesses requiring dependable transportation, freight movement, cargo handling and commercial goods distribution. Logistics services in Pune can support manufacturers, distributors, wholesalers, retailers, warehouses and corporate businesses with planned movement of goods between suppliers, factories, storage facilities and customer locations. As a logistics company Pune businesses can approach for transportation requirements, SSK Logistics focuses on practical coordination based on cargo type, route, vehicle requirements and delivery schedules. Logistics providers Pune services can assist with recurring local transportation as well as regional and interstate movement. Logistics solutions in Pune can be planned for commercial shipments, industrial materials, warehouse transfers and business distribution requirements. As a logistics service provider Pune businesses can use for dedicated transportation support, SSK Logistics can coordinate suitable vehicle arrangements according to the nature and volume of goods. Freight logistics Pune services are suitable for commercial cargo and business consignments, while cargo logistics Pune can support organized movement of goods between different locations. Industrial logistics Pune services can assist manufacturing and industrial businesses with transportation of raw materials, equipment, machinery and finished products. Commercial logistics Pune services are suitable for distributors, traders, retailers and other businesses managing regular shipments. Transportation logistics Pune solutions can be structured around pickup schedules, destinations, cargo requirements and delivery timelines, providing businesses with a practical logistics partner for their transportation needs.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Logistics Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/logistics-in-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Logistics in Pune | Freight, Cargo, Industrial & Commercial Logistics Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics offers logistics services in Pune including freight, cargo, industrial, commercial and transportation logistics for businesses and regular goods movement."
  />

  <meta
    name="keywords"
    content="Logistics in Pune, logistics services in pune, logistics company pune, logistics providers pune, logistics solutions in pune, logistics service provider pune, freight logistics pune, cargo logistics pune, industrial logistics pune, commercial logistics pune, transportation logistics Pune, logistics transportation Pune, freight transportation Pune, cargo transportation Pune, goods transportation Pune, commercial transportation Pune, industrial transportation Pune, logistics management Pune, business logistics Pune, corporate logistics Pune, warehouse logistics Pune, warehouse transportation Pune, supply chain logistics Pune, freight services Pune, cargo services Pune, industrial transportation services Pune, commercial logistics services Pune, goods transport services Pune, logistics partner Pune, B2B logistics services Pune, local logistics Pune, regional logistics Pune, interstate logistics Pune, reliable logistics provider Pune, professional logistics company Pune, logistics support services Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Logisticinpune;